var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.098,
    height: 18.131,
    viewBox: "0 0 21.098 18.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delivery_Truck",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967",
    transform: "translate(0 42.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7113",
    "data-name": "Path 7113",
    d: "M4.121,197.648H.824a.824.824,0,0,1,0-1.648h3.3a.824.824,0,0,1,0,1.648Z",
    transform: "translate(0 -196)",
    fill: "#05f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5968",
    "data-name": "Group 5968",
    transform: "translate(0 39.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7114",
    "data-name": "Path 7114",
    d: "M5.769,117.648H.824a.824.824,0,0,1,0-1.648H5.769a.824.824,0,0,1,0,1.648Z",
    transform: "translate(0 -116)",
    fill: "#05f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5969",
    "data-name": "Group 5969",
    transform: "translate(0 45.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7115",
    "data-name": "Path 7115",
    d: "M2.472,277.648H.824a.824.824,0,0,1,0-1.648H2.472a.824.824,0,0,1,0,1.648Z",
    transform: "translate(0 -276)",
    fill: "#05f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7116",
    "data-name": "Path 7116",
    d: "M18.625,40.945H14.052l.041-.369A4.121,4.121,0,0,0,10,36H2.472a.824.824,0,0,0,0,1.648H10a2.472,2.472,0,0,1,2.457,2.745l-1.16,10.441H8.1a2.472,2.472,0,0,0-4.661,0H2.472a.825.825,0,0,1-.824-.824A.824.824,0,1,0,0,50.01a2.475,2.475,0,0,0,2.472,2.472h.966a2.472,2.472,0,0,0,4.661,0h3.25a2.472,2.472,0,0,0,4.661,0H17.8a2.475,2.475,0,0,0,2.453-2.164l.824-6.593a2.474,2.474,0,0,0-2.453-2.781Zm.824,2.472a.843.843,0,0,1-.006.1l-.3,2.368H17.74a.824.824,0,0,1-.819-.915l.265-2.381h1.44A.825.825,0,0,1,19.449,43.417ZM5.769,52.482a.824.824,0,1,1,.824-.824A.825.825,0,0,1,5.769,52.482Zm7.912,0a.824.824,0,0,1-.823-.793c.094-.841.718-.856.823-.856a.824.824,0,0,1,0,1.648ZM17.8,50.834h-1.79a2.469,2.469,0,0,0-2.882-1.586l.74-6.656h1.659l-.244,2.2a2.472,2.472,0,0,0,2.457,2.745h1.2l-.322,2.577a.824.824,0,0,1-.818.72Z",
    transform: "translate(0 0)",
    fill: "#05f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/Delivery_Truck.6526864be6e0a4676f1c55a727b61f7b.svg";
export { ForwardRef as ReactComponent };